module.exports = __webpack_public_path__ + "fonts/IGUIBetav9.6edd9631.woff2";